module.exports = __webpack_public_path__ + "img/solar.d55774f3.jpg";